import { render } from "./advanced.vue?vue&type=template&id=213f0898&scoped=true"
import script from "./advanced.vue?vue&type=script&lang=js"
export * from "./advanced.vue?vue&type=script&lang=js"

import "./advanced.vue?vue&type=style&index=0&id=213f0898&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213f0898"]])

export default __exports__